import { or, readOnly } from '@ember/object/computed';
import Service, { inject as service } from '@ember/service';
import CampaignModel from 'cio/models/campaign';
import { task, all } from 'ember-concurrency';
import DS from 'ember-data';

export default class CampaignCounterService extends Service {
  @service store!: DS.Store;

  // external API
  @readOnly('_countCampaigns.last.value')
  hasReadyCampaigns!: CampaignModel[];

  @readOnly('_countNewsletters.last.value')
  hasReadyNewsletters!: CampaignModel[];

  @or('hasReadyCampaigns', 'hasReadyNewsletters')
  hasReadyCampaignsOrNewsletters!: boolean;

  fetch = task(
    {
      drop: true,
    },
    async () => {
      await all([this._countCampaigns.perform(), this._countNewsletters.perform()]);
    },
  );

  // private tasks
  _countCampaigns = task(
    {
      drop: true,
    },
    async () => {
      let campaigns = await this.store.findAll('campaign');

      // Must check that created date is different from updated date.
      // Otherwise this will always be true, because of the sample campaigns
      return campaigns.filterBy('wasModified').isAny('allReady');
    },
  );

  _countNewsletters = task(
    {
      drop: true,
    },
    async () => {
      let newsletters = (await this.store.findAll('newsletter')).toArray();

      if (newsletters == null) {
        return false;
      }

      if (newsletters.isAny('isSent')) {
        return true;
      }

      let newsletterCount = newsletters.get('length');

      for (let id = 0; id < newsletterCount; ++id) {
        let newsletter = newsletters[id];
        if (newsletter == null) {
          continue;
        }
        await all([newsletter.findRecipients(), newsletter.get('templates')]);

        if (newsletter.get('readyToSend')) {
          return true;
        }
      }
      return false;
    },
  );
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'campaign-counter': CampaignCounterService;
  }
}
